import { TemplateRef } from '@angular/core';
import { UserService } from './../../services/user.service';
import { Component, ViewChild } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Store } from '@ngrx/store';
import { Notification } from 'src/app/models/notification.model';
import * as NotificationActions from '../../reducers/actions/notification.actions';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
declare const swal: any;
interface AppStateNotification {
    contador: Notification
  }

@Component({
    selector: "page-solicitudes-expedientes",
    templateUrl: "./solicitudesexp.component.html",
    styleUrls: ["./solicitudesexp.component.css"],
    providers: [UserService]
})

export class SolicitudesExpComponent {

    @ViewChild('openModalSolicitud') openModalSolicitud: TemplateRef<any>
    @ViewChild('openModalSolicitud') openModalSolicitudRef: MatDialogRef<any>


    public solicitudes
    public cargado: boolean  = false
    public contador_notification
    public solicitud;
    constructor(private _userService: UserService, private dialog: MatDialog, private spinner: NgxSpinnerService, private store: Store<AppStateNotification>){
        this.getSolicitudes();
        this.store.select('contador').subscribe(
            response => {
                this.contador_notification = response.contador
            },
            error => {
                console.log(error)
            }
        )



    }

    getSolicitudes(){
        this.spinner.show();
        this._userService.getSolicitudes().subscribe(
            response => {
                console.table(response)
                this.spinner.hide();
                this.cargado = true
                this.solicitudes = response;
            },
            error => {
                this.spinner.hide();
                console.log(error)
            }
        )
    }

    castEstado(estado){
        switch(estado){
            case 0: return 'Anulado'
            case 1: return 'Pre-Ingresado'
            case 2: return 'Ingresado'
            case 3: return 'Rechazado'
            default: return 'Anulado'
        }
    }

     openInfo(solicitud){
         this.solicitud = solicitud
        console.log(solicitud)
        if(solicitud.Estado == 3 && (solicitud.Notificado == "" || solicitud.Notificado == null || solicitud.Notificado == undefined)){
            var cont
            console.log("entre aqui en rechazado")
            if(this.contador_notification == 0){
                cont = 0;
            }else{
                cont = this.contador_notification - 1
            }
            this.store.dispatch(new NotificationActions.NotificationUpdate(cont))
            this.marcarSolicitud(solicitud)


            console.table(this.solicitud)

                if(solicitud.nota4 == "" || solicitud.nota4 == null || solicitud.nota4 == undefined){
                    swal({
                        type: 'info',
                        title: 'Respuesta a solicitud',
                        text: `
                       <p>La solicitud aún no recibe ninguna nota por parte del revisor</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                      }).then(
                        () => {
                        }
                      );   

                } else {

                    swal({
                        type: 'info',
                        title: 'Respuesta a solicitud',
                        text: `
                       <p>${solicitud.nota4}</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                      }).then(
                        () => {
                        }
                      );         
                }
                
            
        } else {
            console.log("no rechazado")
            this.marcarSolicitud(solicitud)

                 if(solicitud.nota4 == "" || solicitud.nota4 == null || solicitud.nota4 == undefined){
                    swal({
                        type: 'info',
                        title: 'Respuesta a solicitud',
                        text: `
                       <p>La solicitud aún no recibe ninguna nota por parte del revisor</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                      }).then(
                        () => {
                        }
                      );   
                 } else {

                    swal({
                        type: 'info',
                        title: 'Respuesta a solicitud',
                        text: `
                       <p>${solicitud.nota4}</p>
                        `,
                        showConfirmButton: true,
                        confirmButtonText: 'Aceptar',
                      }).then(
                        () => {
                        }
                      );    
                 }
                 
             
        }


    }




    marcarSolicitud(solicitud){

        if(solicitud.nota4 === ""){
            console.log("nota 4 vacio")
        }else if(solicitud.Notificado){
            console.log("Esta solicitud rechazada ya ha sido notificada")
        }else{
            this._userService.marcarSolicitud(solicitud).subscribe(
                response => {
                    console.log(response)
                },
                error => {
                    console.log(error)
                }
            )
        }
        
    }
    
}